import script from "./Wait.vue?vue&type=script&setup=true&lang=js"
export * from "./Wait.vue?vue&type=script&setup=true&lang=js"

import "./Wait.vue?vue&type=style&index=0&id=4bed845c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bed845c"]])

export default __exports__